import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
	window.localStorage.setItem("token", Cookies.get(TokenKey));

	return Cookies.get(TokenKey)
}
export function setToken(token) {
	return Cookies.set(TokenKey, token)
}

export function removeToken() {
	return Cookies.remove(TokenKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js